// ==========================================
// TOPIC TYPE CONFIGURATION
// ==========================================
// UI metadata and utilities for topic types.

import { TopicType, TopicTypeInfo } from '../ontology.model';

export const TOPIC_TYPES: TopicTypeInfo[] = [
  {
    name: TopicType.Foundational,
    description: 'Primitives and basic arithmetic',
    topics: 'Number, Place Value, Basic Operations',
    example: '$2 + 3 = 5$',
    color: '#fef3c7',
  },
  {
    name: TopicType.Structural,
    description: 'Notations and forms (tools for other topics)',
    topics: 'Standard Form, Fractions, Surds',
    example: '$3.45 \\times 10^4$',
    color: '#dbeafe',
  },
  {
    name: TopicType.Algebraic,
    description: 'Polynomials, equations, and functions',
    topics: 'Quadratics, Linear Equations',
    example: '$x^2 + 2x - 3 = 0$',
    color: '#e0e7ff',
  },
  {
    name: TopicType.Generative,
    description: 'Topics that produce objects from rules or parameters',
    topics: 'Sequences, Series, Combinatorics, Recursion',
    example: '$u_n = ar^{n-1}$',
    color: '#d1fae5',
  },
  {
    name: TopicType.Geometric,
    description: 'Shapes, vectors, and transformations',
    topics: 'Triangles, Vectors, Rotations',
    example: '$\\vec{v} = \\begin{pmatrix} 3 \\\\ 4 \\end{pmatrix}$',
    color: '#fce7f3',
  },
  {
    name: TopicType.Analytic,
    description: 'Calculus and limits',
    topics: 'Differentiation, Integration',
    example: '$\\frac{dy}{dx} = 2x$',
    color: '#f3e8ff',
  },
  {
    name: TopicType.Statistical,
    description: 'Probability and distributions',
    topics: 'Binomial, Normal Distribution',
    example: '$P(X = k) = \\binom{n}{k}p^k(1-p)^{n-k}$',
    color: '#ffedd5',
  },
];

export function getTopicTypeInfo(topicType: TopicType): TopicTypeInfo | undefined {
  return TOPIC_TYPES.find((t) => t.name === topicType);
}

export function getTopicTypeColor(topicType: TopicType | undefined): string {
  if (!topicType) {
    return '#f3f4f6';
  }
  return getTopicTypeInfo(topicType)?.color ?? '#f3f4f6';
}
